module.exports = __webpack_public_path__ + "img/v1-dashboard-mobile-sidebar.7f0d7b6f.png";